import { TextField } from '@mui/material';
import styled from 'styled-components';
import colors from '@/styles/colors';

export const StyledContainer = styled.div`
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  width: 100%;
  & article,
  & article svg {
    width: 100% !important;
  }
`;

export const StyledTextField = styled(TextField)`
  display: flex !important;
  margin-left: auto !important;
  max-width: 200px;
  max-height: 100px !important;
  & label,
  .Mui-focused {
    color: ${colors.light};
  }
  & fieldset {
    border-color: ${(props) => {
      if (props?.error) {
        return '#d32f2f';
      }
      if (!props?.error && props?.value) {
        return colors.success;
      }
      return colors.dark;
    }}!important;
  }
  &:hover fieldset {
    border-color: ${(props) => {
      if (props?.error) {
        return '#d32f2f';
      }
      if (!props?.error && props?.value) {
        return colors.success;
      }
      return colors.lighter;
    }}!important;
  }
  & input,
  textarea {
    color: ${colors.lighter}!important;
  }
  & .Mui-error {
    color: #d32f2f !important;
  }
  & .MuiSelect-select {
    min-width: 16px;
    padding-top: 10.5px;
    padding-bottom: 10.5px;
    color: ${colors.light};
  }
  & .MuiSelect-icon {
    color: ${colors.primary};
  }
`;
